const veros = {
  checkForPreviewResults(controlNumber) {
    return `/homeowner/cases/${controlNumber}/veros/preview/result/view/current`;
  },
  submittalIsRequired(controlNumber) {
    return `/homeowner/cases/${controlNumber}/veros/submit/isrequired`;
  },
  submitResultViewCurrent(controlNumber) {
    return `/homeowner/cases/${controlNumber}/veros/submit/result/view/current`;
  },
  submitInitiate(controlNumber) {
    return `/homeowner/cases/${controlNumber}/veros/submit/initiate`;
  },
};

export { veros };
